// extracted by mini-css-extract-plugin
export default {"csvButton":"RandRDashboard_csvButton__KAisg","statistics":"RandRDashboard_statistics__Lsx5p","statistics__dashboard":"RandRDashboard_statistics__dashboard__Hd+Wo"};